import {createContext} from 'react';
import { User } from './interfaces/User.interface';

const GlobalContext = createContext<User|null>(null);

export default GlobalContext;